import BossProjectile from './BossProjectile';
import BossShip from './BossShip';
import BossWarning from './BossWarning';
import EnemyShip from './EnemyShip';
import Explosion from './Explosion';
import GameOverlay from './GameOverlay';
import LaserShot from './LaserShot';
import MuzzleFlash from './MuzzleFlash';
import PlayerShip from './PlayerShip';
import Powerup from './Powerup';
import Starfield from './Starfield';
import Hazard from './Hazard';
import './Playfield.css';

function Playfield({
  game,
  gameTitle = 'Arcade Shooter',
  playfieldLabel = 'Arcade Shooter playfield',
  levelCount,
  levelAdvanceSeconds,
  onStartGame,
  onStartNextLevel,
  onStartPracticeLevel,
  practiceMode,
  restartLevelName,
  onReturnToLibrary,
  maxExplosions,
  maxMuzzleFlashes,
  selectedPlayableIcon,
}) {
  const playfieldClassName = `playfield${game.explosions.length ? ' playfield-shake' : ''}`;
  const muzzleFlashes = typeof maxMuzzleFlashes === 'number'
    ? (game.muzzleFlashes || []).slice(-maxMuzzleFlashes)
    : (game.muzzleFlashes || []);
  const explosions = typeof maxExplosions === 'number'
    ? game.explosions.slice(-maxExplosions)
    : game.explosions;

  return (
    <div
      className={playfieldClassName}
      aria-label={playfieldLabel}
      role="application"
    >
      <Starfield />

      {game.enemies.map((enemy) => (
        <EnemyShip enemy={enemy} key={enemy.id} />
      ))}

      <BossShip boss={game.boss} />

      {game.bullets.map((bullet) => (
        <LaserShot bullet={bullet} key={bullet.id} />
      ))}

      {(game.bossProjectiles || []).map((projectile) => (
        <BossProjectile projectile={projectile} key={projectile.id} />
      ))}

      {(game.hazards || []).map((hazard) => (
        <Hazard hazard={hazard} key={hazard.id} />
      ))}

      {(game.powerups || []).map((powerup) => (
        <Powerup powerup={powerup} key={powerup.id} />
      ))}

      {muzzleFlashes.map((muzzleFlash) => (
        <MuzzleFlash muzzleFlash={muzzleFlash} key={muzzleFlash.id} />
      ))}

      {explosions.map((explosion) => (
        <Explosion explosion={explosion} key={explosion.id} />
      ))}

      <PlayerShip
        isShielded={game.playerInvulnerableMs > 0}
        lean={game.playerLean ?? 'center'}
        playerX={game.playerX}
        playerY={game.playerY}
        selectedPlayableIcon={selectedPlayableIcon}
      />

      <BossWarning visible={(game.bossWarningMs ?? 0) > 0} />

      {game.status !== 'playing' && (
        <GameOverlay
          status={game.status}
          gameTitle={gameTitle}
          score={game.score}
          levelName={game.levelName}
          levelIndex={game.levelIndex}
          levelCount={levelCount}
          challengeSummary={game.challengeSummary}
          runSummary={game.runSummary}
          levelAdvanceSeconds={levelAdvanceSeconds}
          onStartGame={onStartGame}
          onStartNextLevel={onStartNextLevel}
          onStartPracticeLevel={onStartPracticeLevel}
          practiceMode={practiceMode}
          restartLevelName={restartLevelName}
          onReturnToLibrary={onReturnToLibrary}
        />
      )}
    </div>
  );
}

export default Playfield;
